import React, { useState, useEffect, useRef } from 'react'

import {
  IonIcon,
  IonImg,
  IonButton,
  IonSkeletonText
} from '@ionic/react'
import { closeCircleOutline } from 'ionicons/icons'
import { getAdvertisement, setAdvertisementEvent } from '../../../services/api/advertisements'
import './styles.scss'

export const Advertisement = (props) => {
  const { section, dark } = props
  const [advertisement, setAdvertisement] = useState(false)
  const [image, setImage] = useState(false)
  const itemRef = useRef()

  const remove = () => {
    itemRef.current.style.display = 'none'
  }

  const eventRecord = (params) => {
    setAdvertisementEvent(params)
  }

  const recordWatched = () => {
    eventRecord({
      event: 'watched',
      ad_id: advertisement.id
    })
  }

  useEffect(() => {
    const params = {}
    if (typeof section !== 'undefined') {
      params.section = (section === true)
    }
    getAdvertisement(params).then((response) => {
      setAdvertisement(response)
      eventRecord({
        event: 'served',
        ad_id: response.id
      })
    }).catch(() => {
      setAdvertisement(false)
    })
    return () => {
      setAdvertisement(false)
    }
  }, [section])

  useEffect(() => {
    if (advertisement !== null) {
      const _image = itemRef.current.clientWidth < 768 ? advertisement.photo_mobil : advertisement.photo_pc
      setImage(_image)
    }
  }, [advertisement, itemRef])

  return (
    <div
      ref={itemRef}
      className={dark ? 'advertisement dark' : 'advertisement'}
    >
      <figure>
        {!advertisement &&
          <IonSkeletonText animated />}
        {(advertisement && image) &&
          <a
            href={advertisement.link}
            onClick={() => {
              eventRecord({
                event: 'clicked',
                ad_id: advertisement.id
              })
            }}
            aria-label={`Ver anuncio de ${advertisement.alt}`}
            target='_blank'
            rel='noreferrer noopener'
          >
            <IonImg
              src={image}
              alt={advertisement.alt}
              onIonImgDidLoad={recordWatched}
            />
          </a>}
        <figcaption>
          <p>Anuncio</p>
          <IonButton
            aria-label='Cerrar anuncio'
            onClick={remove}
          >
            <IonIcon icon={closeCircleOutline} />
          </IonButton>
        </figcaption>
      </figure>
    </div>
  )
}
